import React, { useState } from 'react'
import { Form, Modal, Button, Upload, message, Checkbox } from 'antd'
import { connect } from 'dva'
import { Link } from 'react-router-dom'
import { createIdCard } from '../../../api/idCard'
import './Info.module.less'

const props = {
  accept: 'image/png, image/jpg',
  maxCount: 1,
  beforeUpload: () => {
    return false
  },
}

const AddIdCard = ({ dispatch, addIdCardVisible }) => {
  const [front, setFront] = useState()
  const [back, setBack] = useState()
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const handleCancel = () => {
    dispatch({
      type: 'center/save',
      payload: {
        addIdCardVisible: false,
      },
    })
  }
  const frontProps = {
    ...props,
    beforeUpload: (file) => {
      console.log(file)
      setFront(file)
      form.setFieldsValue({
        front: file,
      })
      return false
    },
    onRemove: (file) => {
      setFront(undefined)
      form.setFieldsValue({
        front: undefined,
      })
      console.log('remove', file)
    },
  }
  const backProps = {
    ...props,
    beforeUpload: (file) => {
      setBack(file)
      form.setFieldsValue({
        back: file,
      })
      return false
    },
    onRemove: (file) => {
      setBack(undefined)
      form.setFieldsValue({
        back: undefined,
      })
      console.log('remove', file)
    },
  }
  const handleOk = () => {
    form.validateFields().then((values) => {
      const formData = new FormData()
      formData.append('portraitFile', front)
      formData.append('nationalEmblemFile', back)
      setLoading(true)
      createIdCard(formData)
        .then((res) => {
          console.log(res)
          if (res.code === 0) {
            message.success(res.message)
            dispatch({
              type: 'global/getIdCardCheck',
            })
            handleCancel()
          } else {
            message.error(res.message)
          }
        })
        .finally(() => {
          setLoading(false)
        })
    })
  }
  const onAgreeChange = (e) => {
    form.setFieldsValue({
      agree: e.target.checked ? true : undefined,
    })
  }
  return (
    <Modal
      title="身份证信息"
      visible={addIdCardVisible}
      onCancel={handleCancel}
      width={600}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <Form form={form} preserve={false}>
        <Form.Item
          label="身份证人像面"
          name="front"
          rules={[
            {
              required: true,
              message: '请上传身份证人像面',
            },
          ]}
        >
          <div styleName="upload-photo">
            <Upload {...frontProps}>
              <Button>点击上传</Button>
              <span
                style={{ marginLeft: '20px', color: 'rgba(0, 0, 0, 0.45)' }}
              >
                格式限制：JPG、PNG 请上传小于2MB的图片
              </span>
            </Upload>
          </div>
        </Form.Item>
        <Form.Item
          label="身份证国徽面"
          name="back"
          rules={[
            {
              required: true,
              message: '请上传身份证国徽面',
            },
          ]}
          extra="您的身份证照片信息仅用于实名认证，是您收到转账的基础。"
        >
          <div styleName="upload-photo">
            <Upload {...backProps}>
              <Button>点击上传</Button>
              <span
                style={{ marginLeft: '20px', color: 'rgba(0, 0, 0, 0.45)' }}
              >
                格式限制：JPG、PNG 请上传小于2MB的图片
              </span>
            </Upload>
          </div>
        </Form.Item>
        <Form.Item
          name="agree"
          rules={[
            {
              required: true,
              message: '请同意隐私协议',
            },
          ]}
        >
          <span style={{ color: '#ff8534', marginRight: '8px' }}>*</span>
          <Checkbox onChange={onAgreeChange}>
            同意
            <Link to="/policy/privacy" style={{ color: '#056DE8' }}>
              隐私协议
            </Link>
          </Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default connect(({ center }) => {
  return {
    addIdCardVisible: center.addIdCardVisible,
  }
})(AddIdCard)
